<footer class="signup-landing__footer theme-footer-background">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4">
                <h3>{{ 'Communiquez et Plannifiez' | transloco }}</h3>
                <div class="tools-list tools-list--with-margin" role="list">
                    <img
                        (blur)="tool.focused = false"
                        (focus)="tool.focused = true"
                        *ngFor="let tool of workspace"
                        [alt]="'Image de l\'outil' | transloco"
                        [attr.aria-describedby]="'tooltip-' + tool.title"
                        [attr.aria-hidden]="!tool.focused"
                        [position]="'top'"
                        [signupTooltip]="tool.description | transloco"
                        [src]="tool.assetUrl"
                        [title]="tool.title | transloco"
                        [tooltipFocused]="tool.focused"
                        role="listitem"
                        tabindex="0"
                    />
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-2">
                <h3>{{ 'Stockez et Partagez' | transloco }}</h3>
                <div class="tools-list tools-list--with-margin" role="list">
                    <img
                        (blur)="tool.focused = false"
                        (focus)="tool.focused = true"
                        *ngFor="let tool of storage"
                        [alt]="'Image de l\'outil' | transloco"
                        [attr.aria-describedby]="'tooltip-' + tool.title"
                        [position]="'top'"
                        [signupTooltip]="tool.description | transloco"
                        [src]="tool.assetUrl"
                        [title]="tool.title | transloco"
                        [tooltipFocused]="tool.focused"
                        role="listitem"
                        tabindex="0"
                    />
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <h3>{{ 'Creez et Collaborez' | transloco }}</h3>
                <div class="tools-list tools-list--with-marginx2" role="list">
                    <img
                        (blur)="tool.focused = false"
                        (focus)="tool.focused = true"
                        *ngFor="let tool of onlyOffice"
                        [alt]="'Image de l\'outil' | transloco"
                        [attr.aria-describedby]="'tooltip-' + tool.title"
                        [position]="'top'"
                        [signupTooltip]="tool.description | transloco"
                        [src]="tool.assetUrl"
                        [title]="tool.title | transloco"
                        [tooltipFocused]="tool.focused"
                        role="listitem"
                        tabindex="0"
                    />
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <h3>{{ 'Gerez et Controllez' | transloco }}</h3>
                <div class="tools-list tools-list--with-marginx2" role="list">
                    <img
                        (blur)="tool.focused = false"
                        (focus)="tool.focused = true"
                        *ngFor="let tool of collaborate"
                        [alt]="'Image de l\'outil' | transloco"
                        [attr.aria-describedby]="'tooltip-' + tool.title"
                        [position]="'top'"
                        [signupTooltip]="tool.description | transloco"
                        [src]="tool.assetUrl"
                        [title]="tool.title | transloco"
                        [tooltipFocused]="tool.focused"
                        role="listitem"
                    />
                </div>
            </div>
        </div>
    </div>
    <p *ngIf="invitation && invitation.account && invitation.account.logo" class="signup-landing__footer__copyright">
        Powered by
        <a href="https://www.infomaniak.com" target="_blank"
            ><img alt="Infomaniak" src="/assets/images/ui/logo-infomaniak.svg"
        /></a>
    </p>
</footer>
